<template>
  <Popover ref="messageTemplatePopover" :showHeader="true" headerTitle="Copy Message Template" sizeClass="popover-xlarge">
    <div>
      <LoadingPanel :loading="loading" :loadingError="loadingError" />

      <div v-if="!loading && !loadingError">
        <div class="template-popover-list">
          <StaticDataTable class="static-table-list" striped hover>
            <template v-slot:header>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Method</th>
              </tr>
            </template>
            <template v-slot:body>
              <template v-for="messageTemplate in messageTemplateList">
                <tr :key="messageTemplate.id" @click.prevent="copyClicked(messageTemplate)" class="template-row">
                  <td><strong>{{messageTemplate.name}}</strong></td>
                  <td>{{formatLookupName(messageTemplate.templateType, MessageTemplateTypeLookup)}}</td>
                  <td>{{formatLookupName(messageTemplate.methodType, CommunicationMethodTypeLookup)}}</td>
                </tr>
              </template>
            </template>
            <template v-slot:empty v-if="messageTemplateList.length == 0">No message templates found</template>
          </StaticDataTable>      
        </div>
      </div>
    </div>
  </Popover>
</template>

<style lang="scss" scoped>
.template-popover-list {
  padding: 0.25rem;
  font-size: 13px;
  max-height: 30vh;
  overflow-y: scroll;
}
.template-row {
  cursor:pointer;
}
</style>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'
import FormMixin from '@/mixins/form'

import { MessageTemplateTypeLookup, CommunicationMethodTypeLookup } from '@/store/types'

export default {
  name: 'AutomationCopyMessageTemplatePopover',
  mixins: [FormMixin],
  components: {
    Popover,
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      messageTemplateList: []
    }
  },
  computed: {
  },
  created() {
    this.MessageTemplateTypeLookup = MessageTemplateTypeLookup
    this.CommunicationMethodTypeLookup = CommunicationMethodTypeLookup
  },
  methods: {
    requestData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.adminService.getMessageTemplateList()
      .then(response => {
        this.messageTemplateList = response.data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
    displayFromElement(element) {
      this.$refs.messageTemplatePopover.displayFromElement(element)

      this.requestData()
    },
    copyClicked(messageTemplate) {
      this.$emit('copyClicked', messageTemplate)
      this.$refs.messageTemplatePopover.hidePopover()
    }
  }
}
</script>